import { render, staticRenderFns } from "./packageOrderInfo.vue?vue&type=template&id=a652cd86&scoped=true&"
import script from "./packageOrderInfo.vue?vue&type=script&lang=js&"
export * from "./packageOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./packageOrderInfo.vue?vue&type=style&index=0&id=a652cd86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a652cd86",
  null
  
)

export default component.exports